import { useEffect } from 'react';
import { runInAction } from 'mobx';
import { reactionsStore } from 'state/store';

/**
 * Хук для очистки старых реакций при возврате на вкладку.
 * Удаляет реакции, которые были созданы более 1 секунды назад.
 */
export const useReactionsVisibilityCleanup = () => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                const now = Date.now();
                runInAction(() => {
                    reactionsStore.reactions = reactionsStore.reactions.filter((r) => now - r.timestamp < 1000);
                });
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
};
